import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css'],
})
export class InfoModalComponent implements OnInit {
  naglowek: string;
  tresc: string;

  constructor(public router: Router, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  ok() {
    this.activeModal.close(true);
  }
}
